import { Box, Button, IconButton, Typography } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import ClearIcon from '@mui/icons-material/Clear'
import AddHomeIcon from '@mui/icons-material/AddHome';
import { DataGrid } from '@mui/x-data-grid'
import { useState } from 'react'
import { getTimeStringForView } from '../util/componentutil'


const TenantTable = (props) =>{

  const [pageSize, setPageSize] = useState(5);
  const actionRender = (params) => {
    return (
      <>
        <EditIconButton data={params.row} />
        <DeleteIconButton data={params.row} />
      </>
    )
  }

  const EditIconButton = (props) => {
    return (
      <IconButton onClick={(e) => onEdit(props.data)}>
        <EditIcon />
      </IconButton>
    )
  }

  const DeleteIconButton = (props) => {
    return (
      <IconButton onClick={(e) => onDelete(props.data)}>
        <ClearIcon />
      </IconButton>
    )
  }


  const onDelete = (params) => {
    props.delete(params)
  }

  const onEdit = (params) => {
    props.update(params)
  }

  const onNew = (params) => {
    props.create(params);
  }

  const getLabelforDatetime = (params) => {
    return getTimeStringForView(params.row.entrytime)
  }

  const columns = [
    {
      field: 'id',
      headerName: 'テナントID',
      width: 150,
      headerClassName: 'header-styles',
    },
    {
      field: 'info',
      headerClassName: 'header-styles',
      hide: true
    },
    {
      field: 'name',
      headerName: '名称',
      width: 300,
      headerClassName: 'header-styles',
    },
    {
      field: 'tenant',
      headerName: '名称（英）',
      width: 100,
      headerClassName: 'header-styles',
    },
    {
      field: 'entrytime',
      headerName: '登録日時',
      width: 155,
      headerClassName: 'header-styles',
      valueGetter: getLabelforDatetime,
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 100,
      headerClassName: 'header-styles',
      renderCell: (params) => actionRender(params),
    },
  ];

  return (
    <>
      <Box sx={{ml:0,mb:1}}>
        <Button variant="contained" onClick={(e) => onNew({})} startIcon={<AddHomeIcon />} sx={{mt:1,ml:2,mb:0}}>
          <Typography variant={"body"}>新規テナント作成</Typography>
        </Button>
      </Box>
      <Box sx={{ height: 372, width: '807px' }}>
        <DataGrid
          rows={props.data}
          rowHeight={40}
          columns={columns}
          pageSize={pageSize}
          loading={props.loading}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[2, 5, 10,100]}
          rowSpacingType='border'
          experimentalFeatures={{ newEditingApi: true }}
          sx={{ color: '#939191' }}
        />
      </Box>
    </>
  );
}

export default TenantTable